import React, { PureComponent } from "react";
import StatsService from "../../apiservices/StatsService";
import { Loader } from "@fluentui/react-northstar";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

export default class OutboundByAgentTimers extends PureComponent {
  state = {
    activeIndex: 0,
    data: [],
    isLoading: true,
  };
  componentDidMount() {
    const username = sessionStorage.getItem("userName");
    const tokenString = sessionStorage.getItem("tokenStats");
    const company = sessionStorage.getItem("company");

    StatsService.getAttendedByAgentOutboundNum(
      this.props.initDate,
      this.props.endDate,
      tokenString,
      username,
      company
    ).then((res) => {
      for (let obj of res.data) {
        this.setState((prevState) => ({
          data: [
            ...prevState.data,
            {
              name: obj.name,
              "Avg Time": obj.timeCall,
            },
          ],
        }));
      }
      this.setState({
        isLoading: false,
      });
    });
  }
  onPieEnter = (_, index) => {
    this.setState({
      activeIndex: index,
    });
  };
  render() {
    return (
      <>
        {this.state.isLoading ? (
          <Loader
            styles={{
              marginTop: "20%",
            }}
          />
        ) : (
          <ResponsiveContainer>
            <BarChart
              width={800}
              height={300}
              data={this.state.data}
              margin={{
                top: 20,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />

              <Bar dataKey="Avg Time" stackId="a" fill="#82ca9d" />
            </BarChart>
          </ResponsiveContainer>
        )}
      </>
    );
  }
}
